<!--=========================================
=            ANALYTIC APEXCHARTS            =
==========================================-->

<template>
  <v-row class="transparent ma-1 elevation-0">
    <v-flex style="z-index:0" class="pa-3" xs12 md3 color="transparent elevation-0">
      <v-card color="secondary">
        <div class="ul-widget__chart-info">
          <h5 class="heading white--text subtitle-1">Approve</h5>
          <div class="ul-widget__chart-number">
            <h2 class="t-font-boldest white--text">$500</h2>
            <small class="caption white--text subtitle-2">46% compared to last year</small>
          </div>
        </div>

        <div id="basicArea-chart"></div>
      </v-card>
    </v-flex>
    <v-flex style="z-index:0" class="pa-3" xs12 md3 color="transparent elevation-0">
      <v-card color="error">
        <div class="ul-widget__chart-info">
          <h5 class="heading white--text subtitle-1">Income</h5>
          <div class="ul-widget__chart-number">
            <h2 class="t-font-boldest white--text">$1000</h2>
            <small class="caption white--text subtitle-2">46% compared to last year</small>
          </div>
        </div>

        <div id="basicArea-chart2"></div>
      </v-card>
    </v-flex>
    <v-flex style="z-index:0" class="pa-3" xs12 md3 color="transparent elevation-0">
      <v-card color="primary">
        <div class="ul-widget__chart-info">
          <h5 class="heading white--text subtitle-1">Approve</h5>
          <div class="ul-widget__chart-number">
            <h2 class="t-font-boldest white--text">$500</h2>
            <small class="caption white--text subtitle-2">46% compared to last year</small>
          </div>
        </div>

        <div id="basicArea-chart3"></div>
      </v-card>
    </v-flex>
    <v-flex style="z-index:0" class="pa-3" xs12 md3 color="transparent elevation-0">
      <v-card color="blue accent-2">
        <div class="ul-widget__chart-info">
          <h5 class="heading white--text subtitle-1">Transation</h5>
          <div class="ul-widget__chart-number">
            <h2 class="t-font-boldest white--text">$44,909</h2>
            <small class="caption white--text subtitle-2">46% compared to last year</small>
          </div>
        </div>

        <div id="basicArea-chart4"></div>
      </v-card>
    </v-flex>
  </v-row>
</template>
<script>
export default {
  mounted() {
    var e = {
      chart: {
        height: 100,
        type: "area",
        zoom: {
          enabled: !1
        },
        sparkline: {
          enabled: !0
        },
        toolbar: {
          show: !1,
          tools: {
            download: !1
          }
        }
      },
      dataLabels: {
        enabled: !1
      },
      stroke: {
        curve: "straight",
        width: 1
      },
      series: [
        {
          name: "income 1",
          data: [31, 40, 28, 51, 42, 109, 100]
        },
        {
          name: "income 2",
          data: [11, 32, 45, 32, 34, 52, 41]
        }
      ],
      colors: ["#ffffff", "#f1f1f1"]
    };

    new ApexCharts(document.querySelector("#basicArea-chart"), e).render();
    e = {
      chart: {
        height: 100,
        type: "area",
        zoom: {
          enabled: !1
        },
        sparkline: {
          enabled: !0
        },
        toolbar: {
          show: !1,
          tools: {
            download: !1
          }
        }
      },
      dataLabels: {
        enabled: !1
      },
      stroke: {
        curve: "smooth",
        width: 1
      },
      series: [
        {
          name: "approve 1",
          data: [90, 40, 28, 51, 42, 109, 100]
        },
        {
          name: "approve 2",
          data: [11, 90, 45, 32, 34, 52, 41]
        }
      ],
      colors: ["#ffffff", "#f1f1f1"]
    };
    new ApexCharts(document.querySelector("#basicArea-chart2"), e).render();
    e = {
      chart: {
        height: 100,
        type: "area",
        zoom: {
          enabled: !1
        },
        sparkline: {
          enabled: !0
        },
        toolbar: {
          show: !1,
          tools: {
            download: !1
          }
        }
      },
      dataLabels: {
        enabled: !1
      },
      stroke: {
        curve: "smooth",
        width: 1
      },
      series: [
        {
          name: "transaction 1",
          data: [11, 40, 28, 51, 42, 109, 100]
        },
        {
          name: "transaction 2",
          data: [100, 40, 45, 32, 34, 0, 41]
        }
      ],
      colors: ["#ffffff", "#f1f1f1"]
    };
    new ApexCharts(document.querySelector("#basicArea-chart3"), e).render();
    e = {
      chart: {
        height: 100,
        type: "area",
        zoom: {
          enabled: !1
        },
        sparkline: {
          enabled: !0
        },
        toolbar: {
          show: !1,
          tools: {
            download: !1
          }
        }
      },
      dataLabels: {
        enabled: !1
      },
      stroke: {
        curve: "straight",
        width: 1
      },
      series: [
        {
          name: "sales 1",
          data: [31, 40, 28, 51, 42, 109, 100]
        },
        {
          name: "sales 2",
          data: [11, 32, 90, 32, 34, 52, 41]
        }
      ],
      colors: ["#ffffff", "#f1f1f1"]
    };
    new ApexCharts(document.querySelector("#basicArea-chart4"), e).render();
    e = {
      chart: {
        height: 100,
        type: "area",
        zoom: {
          enabled: !1
        },
        sparkline: {
          enabled: !0
        },
        toolbar: {
          show: !1,
          tools: {
            download: !1
          }
        }
      },
      dataLabels: {
        enabled: !1
      },
      stroke: {
        curve: "straight",
        width: 1
      },
      series: [
        {
          name: "approve 1",
          data: [31, 40, 28, 51, 42, 109, 100]
        }
      ],
      colors: ["#ffffff", "#f1f1f1"]
    };
  }
};
</script>
<style scoped>
.ul-widget__chart-info {
  padding: 15px;
}

.ul-widget__row {
  align-items: center;
  display: flex;
}

.ul-widget__content {
  margin-left: 30px;
}

.ul-widget__row-v2 {
  text-align: center;
  text-align: -webkit-center;
}

.ul-widget-stat__font i {
  font-size: 35px;
}

.ul-widget__content-v4 {
  text-align: center;
}

.ul-faq__details {
  margin: 70px 0;
}

.ul-faq__list-details ul {
  padding-left: 10px;
  margin: 0;
}

.ul-faq__list-details ul li {
  list-style: none;
  color: transparent;
  padding: 5px 0;
  font-weight: 700;
}

.ul-widget-card__info {
  display: flex;
  justify-content: space-between;
}

.ul-widget-card__info span p:first-child {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 2px;
}

.ul-widget-card__info span p:last-child {
  font-size: 17px;
  margin: 0;
}

.ul-widget-card__progress-rate {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  margin-bottom: 5px;
}

.ul-widget-card__progress-rate span {
  font-weight: 700;
}

.ul-widget-card__progress-rate span:last-child {
  font-weight: 700;
  color: transparent;
}

.progress--height {
  height: 10px;
}

.ul-widget-card__user-info {
  text-align: center;
}

.ul-widget-card--line {
  border-bottom: 1px solid transparent;
  padding-bottom: 20px;
}

.ul-widget-card--line:last-child {
  border-bottom: none;
}

.ul-widget-card__rate-icon {
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
}

.ul-widget-card__rate-icon.\--version-2 {
  justify-content: flex-start;
}

.ul-widget-card__rate-icon.\--version-2 span {
  margin-right: 18px;
}

.ul-widget-card__rate-icon span i {
  font-size: 14px;
}

.ul-widget-card__rate-icon span {
  font-size: 15px;
}

.ul-widget-card__rate-icon span i {
  font-size: 16px;
  font-weight: 600;
  margin-right: 2px;
}

.ul-widget-card__full-status {
  display: flex;
  justify-content: space-between;
}

.ul-widget-card__status1 {
  display: grid;
  text-align: -webkit-center;
  text-align: center;
}

.ul-widget-card__status1 span:first-child {
  font-size: 1.25rem;
  font-weight: 600;
}

.ul-widget6__dot.ul-widget-card__dot-xl {
  padding: 1.35rem;
}

.ul-widget-s6__badge .ul-widget-card__dot {
  position: relative;
}

.ul-widget6__dot.ul-widget-card__dot-xl i {
  position: absolute;
  top: 35%;
  content: "";
  left: 35%;
}

.ul-widget-s6__items.ul-widget-card__position:before {
  left: 20px;
  top: 0;
}

.ul-widget-card__item {
  display: flex;
  align-items: center;
  padding: 20px 0;
}

.ul-widget-card__info-v2 {
  display: grid;
  /* margin-right: 2px; */
  margin-left: 20px;
}
</style>

<!--====  End of ANALYTIC APEXCHARTS  ====-->
